var exports = {
  "Qs": "DomainMovedStepsModal.module__content___NkFjbG",
  "Ci": "DomainMovedStepsModal.module__steps___NkFjbG",
  "PM": "DomainMovedStepsModal.module__step___NkFjbG",
};

module.exports = exports;
